import { createContext, useContext } from "react";
import {
  ORDER_LIST_PATH,
  INVOICES_LIST_PATH,
  LEADS_PATH,
  TASKS_LIST_PATH,
  CALENDAR_SCHEDULE_PATH,
  USERS_LIST_PATH,
} from "../../navigations/path";

/** Where each dashboard module lives, and the permission its list page needs. */
export const DRILLDOWN_MODULES = {
  orders: { path: ORDER_LIST_PATH, permission: "order-list" },
  invoices: { path: INVOICES_LIST_PATH, permission: "invoice-list" },
  leads: { path: LEADS_PATH, permission: "lead-list" },
  tasks: { path: TASKS_LIST_PATH, permission: "task-list" },
  meetings: { path: CALENDAR_SCHEDULE_PATH, permission: "meeting-list" },
  users: { path: USERS_LIST_PATH, permission: "user-list" },
};

/**
 * Provided by the Dashboard page: the filters the dashboard was last loaded with
 * ({ date_from, date_to, team_id }) and whether cards are scoped to the logged-in user.
 */
export const DashboardDrilldownContext = createContext(null);

export const useDrilldownContext = () => useContext(DashboardDrilldownContext);

/** Query param a list page reads to start with its own Status filter selected (see the Orders page). */
export const LIST_STATUS_PARAM = 'list_status';

/**
 * `/module?dd_metric=…&dd_from=…` for a card; the list page turns it into the dashboard's query.
 * A card with `listStatus` instead opens the list with that status chosen in the page's Status
 * filter — it needs no dashboard metric on the backend.
 */
export const buildDrilldownPath = ({ module, metric, status, label, listStatus }, ctx) => {
  const target = DRILLDOWN_MODULES[module];
  if (!target) return null;
  if (listStatus) return `${target.path}?${new URLSearchParams({ [LIST_STATUS_PARAM]: listStatus })}`;
  if (!metric) return null;

  const search = new URLSearchParams({ dd_metric: metric });
  const filters = ctx?.filters ?? {};
  if (filters.date_from) search.set("dd_from", filters.date_from);
  if (filters.date_to) search.set("dd_to", filters.date_to);
  if (filters.team_id) search.set("dd_team", filters.team_id);
  if (ctx?.scopeToUser) search.set("dd_user", "me");
  if (status) search.set("dd_status", status);
  if (label) search.set("dd_label", label);

  return `${target.path}?${search.toString()}`;
};
